if (!customElements.get("countdown-timer")) {
  class Countdown extends HTMLElement {
    constructor() {
      super();

      this.enableMockTimer =
        this.getAttribute("data-enable-mock-timer") === "true";

      if (this.enableMockTimer) {
        const INFINITE_DAYS =
          Number(this.getAttribute("data-enable-mock-picker-day")) || 2;
        const DIFF_HOURS =
          Number(this.getAttribute("data-enable-mock-picker-hours")) || 3;
        const now = new Date();
        const futureDate = new Date(
          now.getTime() + (INFINITE_DAYS * 24 + DIFF_HOURS) * 60 * 60 * 1000
        );
        const year = futureDate.getFullYear();
        const month = String(futureDate.getMonth() + 1).padStart(2, "0");
        const day = String(futureDate.getDate()).padStart(2, "0");
        const hours = String(futureDate.getHours()).padStart(2, "0");
        const minutes = String(futureDate.getMinutes()).padStart(2, "0");
        this.userDate = `${year}-${month}-${day}`;
        this.userTime = `${hours}:${minutes}`;
      } else {
        this.userDate = this.getAttribute("data-date");
        this.userTime = this.getAttribute("data-time");
      }

      this.interval;
      this.setInterval(this.userDate, this.userTime);
    }

    updateNumber(el, newValue) {
      if (!el) return;
      const digits = String(newValue)
        .padStart(el.children.length, "0")
        .split("");

      el.querySelectorAll(".countdown__digit").forEach((digitEl, index) => {
        const newDigit = digits[index];
        const currentDigit =
          digitEl.dataset.value || digitEl.textContent.trim();

        if (currentDigit === newDigit) return;

        digitEl.dataset.value = newDigit;

        const oldSpan = document.createElement("span");
        oldSpan.textContent = currentDigit;
        oldSpan.classList.add("old");

        const newSpan = document.createElement("span");
        newSpan.textContent = newDigit;
        newSpan.classList.add("new");

        digitEl.innerHTML = "";
        digitEl.appendChild(oldSpan);
        digitEl.appendChild(newSpan);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            digitEl.classList.add("animate");
          });
        });

        setTimeout(() => {
          digitEl.classList.remove("animate");
          digitEl.innerHTML = `<span>${newDigit}</span>`;
        }, 450);
      });
    }

    onInit(userDate, userTime) {
      this.countdown = this.querySelector(".countdown__main");
      this.daysEl = this.querySelector(".countdown_block_days");
      this.hoursEl = this.querySelector(".countdown_block_hours");
      this.minutesEl = this.querySelector(".countdown_block_minutes");
      this.secondsEl = this.querySelector(".countdown_block_seconds");
      this.section = this.closest(".countdown");

      const countdownDate = new Date(`${userDate}T${userTime}`);

      const now = new Date();
      const distance = countdownDate.getTime() - now.getTime();

      if (distance < 0) {
        clearInterval(this.interval);
        this.countdown.style.display = "none";
        if (this.section) this.section.style.display = "none";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );

      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.updateNumber(this.daysEl, days);
      this.updateNumber(this.hoursEl, hours);

      this.updateNumber(this.minutesEl, minutes);
      this.updateNumber(this.secondsEl, seconds);
    }

    setInterval(userDate, userTime) {
      clearInterval(this.interval);
      this.interval = setInterval(
        this.onInit.bind(this, userDate, userTime),
        1000
      );
    }
  }

  customElements.define("countdown-timer", Countdown);
}
